import appConf from "../app-conf";
const setup = appConf[process.env.REACT_APP_CLIENT];
const environment = process.env.NODE_ENV;
const project = "Account Transaction List";
const server = null;
const service = null;
const config = {
  details: {
    project,
    server,
    environment,
    service,
  },
  application: {
    account: {
      api: {
        headers: {
          'Content-Type': 'application/json',
          'moduleCode': setup.setup.thor.moduleCode,
          'Authorization': null,
        },
        endpoints: {
          transaction: {
          
            url: setup.setup.api.countdown_v1.url[environment] + '/transactions/history/',
            method: 'GET'
          }
        }
      }
    }
  },
  routes: {
    label: "Transaction List",
    prefix: "/account/transaction/list"
  },
  setup
}

export default config;
